export var radius = {
  s: '2px',
  m: '4px',
  l: '6px',
  xl: '8px',
  circle: '50%'
};
export default radius;